import { useQuery } from '@tanstack/react-query';
import { getInboxConversations } from '../services/api/implementation/impl';

export const INBOX_SUMMARY_KEY = ['inboxSummary'];

const EMPTY_SUMMARY = { unread_conversations: 0, unread_messages: 0 };

/**
 * Lightweight unread-summary source for the nav/tab badge.
 * Polls the conversations endpoint (limit 1) for the summary and refetches on
 * window focus. While the Inbox is open it also mirrors its live summary into
 * this same cache key, so mark-read / SSE updates reflect instantly.
 */
export function useInboxUnread({ enabled = true } = {}) {
  const { data } = useQuery({
    queryKey: INBOX_SUMMARY_KEY,
    enabled,
    queryFn: async () => {
      const result = await getInboxConversations({ limit: 1 });
      return result?.summary || EMPTY_SUMMARY;
    },
    refetchInterval: 30000,
    refetchOnWindowFocus: true,
    staleTime: 15000
  });

  return data || EMPTY_SUMMARY;
}

export default useInboxUnread;
